<section class="wrapper">
  <span class="title_access">{{ 'access_control.list.title' | translate }}</span>
  <header>
    <div class="header-left">
      <app-table-filter
        [dataSource]="tableComponent?.dataSource"
        [label]="'access_control.list.search' | translate">
      </app-table-filter>
    </div>
    <div class="header-actions">
      <button class="bciti-button bciti-button--black-inversed" (click)="openEditAreasDialog()">
        {{ 'access_control.list.assign' | translate }}
      </button>
      <button [routerLink]="['/access-control/new']" class="bciti-button bciti-button--black">
        {{ 'access_control.list.create' | translate }}
      </button>
    </div>
  </header>
  <section class="content">
    <app-access-control-table></app-access-control-table>
  </section>
</section>